export type IModifiedType = "Add" | "Set" | "Remove";

export interface IHashMap<T> extends IIdEntity {
    modified?: IModifiedType;
    previousState?: T;
    fromServer?: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter?: number;
}

export enum SyncType {
    HOS = 1,
    DVIR = 2,
    Shipments = 3,
    TrailerAttachments = 4,
    Messages = 5,
    UserHosRuleSet = 6,
    DriverChange = 7,
    Trip = 8,
    TripAnnotation = 9,
    GroupLinkedDevice = 10,
    Media = 11,
    Coaching = 12
}

export enum SyncQueueGroup {
    HOS = "HOS",
    DVIR = "DVIR",
    SHIPMENTS = "SHIPMENTS",
    MESSAGES = "MESSAGES",
    DRIVER_CHANGE = "DRIVER_CHANGE",
    TRIP = "TRIP",
    COACHING = "COACHING"
}

// Map each SyncType to its queue group for parallel execution
export const SYNC_TYPE_TO_QUEUE_GROUP: Record<SyncType, SyncQueueGroup> = {
    [SyncType.HOS]: SyncQueueGroup.HOS,
    [SyncType.UserHosRuleSet]: SyncQueueGroup.HOS,

    [SyncType.DVIR]: SyncQueueGroup.DVIR,
    [SyncType.TrailerAttachments]: SyncQueueGroup.DVIR,
    [SyncType.Media]: SyncQueueGroup.DVIR,

    [SyncType.Shipments]: SyncQueueGroup.SHIPMENTS,

    [SyncType.Messages]: SyncQueueGroup.MESSAGES,

    [SyncType.DriverChange]: SyncQueueGroup.DRIVER_CHANGE,

    [SyncType.Trip]: SyncQueueGroup.TRIP,
    [SyncType.TripAnnotation]: SyncQueueGroup.TRIP,
    [SyncType.GroupLinkedDevice]: SyncQueueGroup.TRIP,

    [SyncType.Coaching]: SyncQueueGroup.COACHING
};

// Reverse mapping: queue group to sync types
export const QUEUE_GROUP_TO_SYNC_TYPES: Record<SyncQueueGroup, SyncType[]> = {
    [SyncQueueGroup.HOS]: [SyncType.HOS, SyncType.UserHosRuleSet],
    [SyncQueueGroup.DVIR]: [SyncType.DVIR, SyncType.TrailerAttachments, SyncType.Media],
    [SyncQueueGroup.SHIPMENTS]: [SyncType.Shipments],
    [SyncQueueGroup.MESSAGES]: [SyncType.Messages],
    [SyncQueueGroup.DRIVER_CHANGE]: [SyncType.DriverChange],
    [SyncQueueGroup.TRIP]: [SyncType.Trip, SyncType.TripAnnotation, SyncType.GroupLinkedDevice],
    [SyncQueueGroup.COACHING]: [SyncType.Coaching]
};
